import React from "react";
import type { createTheme , ThemeOptions } from "@mui/material";

export type DefaultTheme = ReturnType<typeof createTheme>;

const themeDefaultObject: ThemeOptions = {
  theme: "default",
  typography: {
    body1: {
      fontSize: "0.875rem",
    },
  },
  shape: {
    borderRadius: 0,
  },
  palette: {
    background: {
      default: "#fcfcfc",
    },
    primary: {
      light: "#e9f3fc",
      main: "#1E88E5",
      dark: "#005cb2",
    },
  },
  buttons: {
    main: {},
    secondary: {},
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          lineHeight: "1.1876em",
        },
      },
    },
    "MuiTableCell": {
      styleOverrides: {
        root: {
          border: "1px solid rgba(224, 224, 224, 1)",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          lineHeight: "1.1876em",
        },
        input: {
          fontSize: "1rem",
          height: "1.1876em",
          "&.MuiInputBase-inputMarginDense": {
            paddingTop: "12px",
            paddingBottom: "12px",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          fontSize: "1rem",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        colorSecondary: {
          color: "rgba(0, 0, 0, 0.3)",
          "&$checked": {
            color: "#1E88E5",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          fontSize: "1rem",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          minWidth: "max-content",
          fontWeight: 700,
          backgroundColor: "#1E88E5",
          color: "white",
          "&:hover": {
            backgroundColor: "#005cb2",
            boxShadow: "none",
          },
          boxShadow: "none",
        },
        containedSecondary: {
          minWidth: "max-content",
          fontWeight: 700,
          backgroundColor: "#E9F3FC",
          color: "#1E88E5",
          "&:hover": {
            backgroundColor: "#d7ecfc",
            boxShadow: "none",
          },
          boxShadow: "none",
        },
      },
    },
  },
};

export default themeDefaultObject;
